import { Helmet } from 'react-helmet';
import { FeatureFlagContainer } from '../components/feature-flags.container';

export const ISConfigFeatureFlagsDetails: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Is config - Feature Flags</title>
      </Helmet>
      <FeatureFlagContainer />
    </>
  );
};
